import api from "src/services/api";

export type TipoVisitaUE =
  | "GERENTE_OPS"
  | "LIDER_AGENTIS"
  | "USR_3663500"
  | "USR_4218167"
  | "TEC_SST";

export type CategoriaPreguntaUE =
  | "OPCIONES"
  | "OPCIONES_MULTIPLE"
  | "TEXTO"
  | "COMENTARIO"
  | "FECHA";

export interface PreguntaOpcionUE {
  id?: number;
  tipo_respuesta_id?: number;
  codigo: string;
  etiqueta: string;
  orden?: number;
}

export interface PreguntaUE {
  id: number;
  codigo: string;
  texto: string;
  tipo_respuesta_id: number;
  tipo_respuesta: string;
  categoria: CategoriaPreguntaUE;
  orden?: number;
  requerido?: boolean;
  opciones: PreguntaOpcionUE[];
}

export interface CampoCabeceraUE {
  codigo: string;
  texto: string;
  requerido?: boolean;
  autocompletar?: boolean;
  mostrar?: boolean;
  valor_defecto?: string;
  opciones?: PreguntaOpcionUE[];
}

export interface OpcionesVisitaUEResponse {
  tipo_visita: TipoVisitaUE;
  preguntas: PreguntaUE[];
  campos_cabecera: {
    sector: CampoCabeceraUE;
    responsable_visita: CampoCabeceraUE;
    motivo_visita: CampoCabeceraUE;
  };
}

export interface AccesoVisitaUE {
  tiene_acceso: boolean;
  tipo_visita: TipoVisitaUE | null;
  usuario?: string;
  cargo?: string;
}

export interface ContextoVisitaUE {
  ps?: { id: number; codigo: string; nombre: string };
  fiscal?: { nombre?: string; correo?: string };
}

export interface PuntoServicioUE {
  id: number;
  ps_nombre: string;
  ps_codigo: string;
}

export interface VisitaUERegistro {
  id: number;
  ps_id: number;
  ps_codigo: string;
  ps_nombre: string;
  sector?: string;
  responsable_visita?: string;
  motivo_visita?: string;
  tipo_visita: TipoVisitaUE;
  fecha_visita?: string;
  creado_por_usuario?: string;
  creado_por_cargo?: string;
  fecha_creacion?: string;
}

export interface RespuestaPayload {
  codigo: string;
  respuesta: string | null;
}

export interface CrearVisitaUEPayload {
  ps_id?: number;
  ps_codigo?: string;
  /** false = lugar tipeado libremente (no es PS del sistema). Por defecto true. */
  es_cliente?: boolean;
  /** Nombre del lugar cuando es_cliente=false. */
  ps_nombre?: string;
  sector: string;
  responsable_visita: string;
  motivo_visita: string;
  fecha_visita?: string;
  respuestas: RespuestaPayload[];
}

export const obtenerAccesoVisitaUE = async (): Promise<AccesoVisitaUE> => {
  const { data } = await api.get("visitas-unidades-especializadas/acceso");
  if (data?.error) throw new Error(data.error);
  return data?.datos || { tiene_acceso: false, tipo_visita: null };
};

export const listarOpcionesVisitaUE = async (): Promise<OpcionesVisitaUEResponse> => {
  const { data } = await api.get("visitas-unidades-especializadas/opciones");
  if (data?.error) throw new Error(data.error);
  return data?.datos as OpcionesVisitaUEResponse;
};

export const buscarPuntosServicioVisitaUE = async (
  q: string
): Promise<PuntoServicioUE[]> => {
  const suffix = q ? `?q=${encodeURIComponent(q)}` : "";
  const { data } = await api.get(
    `visitas-unidades-especializadas/puntos-servicio${suffix}`
  );
  if (data?.error) throw new Error(data.error);
  return data?.datos || [];
};

export const obtenerContextoVisitaUE = async (params: {
  psId?: number;
  psCodigo?: string;
}): Promise<ContextoVisitaUE | null> => {
  const query = params.psId
    ? `ps_id=${params.psId}`
    : `ps_codigo=${encodeURIComponent(String(params.psCodigo || ""))}`;
  const { data } = await api.get(
    `visitas-unidades-especializadas/contexto?${query}`
  );
  if (data?.error) throw new Error(data.error);
  return data?.datos || null;
};

export const crearVisitaUE = async (payload: CrearVisitaUEPayload) => {
  const { data } = await api.post("visitas-unidades-especializadas/", payload);
  if (data?.error) throw new Error(data.error);
  return data;
};

export const listarVisitasUE = async (): Promise<VisitaUERegistro[]> => {
  const { data } = await api.get("visitas-unidades-especializadas/listar");
  if (data?.error) throw new Error(data.error);
  return data?.datos?.datos || data?.datos || [];
};
